import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { DtGrid2 } from "../common/DtGrid2";
import { workorderManagementColumns } from "./WorkorderManagementColumns";
import WorkorderManagementBottomButtons from "./WorkorderManagementBottomButtons";
import WorkorderManagementDefaultRightClick from "./WorkorderManagementDefaultRightClick";
import WorkorderManagementSearch from "./WorkorderManagementSearch";
import {
    assignWorkorderItemRedux,
    onClearAssigned,
    onSetFilters,
    onSetPage,
    onSetSelectedWorkorders,
    onSetShowClosed,
    onSetWorkorderSearch,
    setWorkorderItemsError
} from "../../redux/slices/workorderItems.feature";
import { getWorkorderEnquiryActiveButtons } from "../../aplUtils/permissions";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { useNavigate } from "react-router-dom";
import { IRootState } from "../../types/redux/IRootStore";
import { WorkorderItem } from "../../types/workorderItem";
import { DtGridPropsOptions2 } from "../../types/dtGridPropsOptions2";
import { translateColumns, translateString } from "../../translations/gridTranslationHelper";
import { onSetSort } from "../../redux/slices/workorderItems.feature";
import { bootboxConfirm } from "../common/bootboxWrapper";
import { ActivityType } from "../../types/activityType";
import ModalError from "../common/ModalError";

const WorkorderManagementDefault = (props: { activityType: ActivityType }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const aplSettings = AplSettingsSelector();
    const workorderItemsRedux = useSelector((state: IRootState) => state.workorderItems);

    const dtGridOptns: DtGridPropsOptions2 = {
        data: workorderItemsRedux.workorderItems,
        columnData: translateColumns(workorderManagementColumns(aplSettings.siteId, aplSettings.culture), aplSettings.culture),
        defaultSort: {
            field: ["startDate"],
            direction: ["desc"]
        },
        selectType: "single",
        colouring: true,
        headerFilters: true,

        setSelectedItems: function (x: WorkorderItem[]) {
            dispatch(onSetSelectedWorkorders(x));
        },
        selectedItems: workorderItemsRedux.selectedWorkorders,
        tableName: "tblWorkorders",
        tableClass: "table-workorders",
        paging: true,
        showSpinner: workorderItemsRedux.workorderItems.length === 0 && workorderItemsRedux.workorderItemsLoading,
        rowId: "operationId",
        loading: workorderItemsRedux.workorderItemsLoading,
        pageLength: 20,
        sort: workorderItemsRedux.sort,
        filters: workorderItemsRedux.filters,
        setFilters: x => {
            dispatch(onSetFilters(x));
        },
        setSort: x => {
            dispatch(onSetSort(x));
        },
        setPage: x => {
            dispatch(onSetPage(x));
        },
        page: workorderItemsRedux.page
    };

    const getOptions = () => {
        let opts = getWorkorderEnquiryActiveButtons(workorderItemsRedux.selectedWorkorders);

        return {
            ...opts,
            activityType: props.activityType,
            offlineLablClick: () => {
                navigate(
                    `/labels/${workorderItemsRedux.selectedWorkorders[0].lineId}/${workorderItemsRedux.selectedWorkorders[0].operationId}`
                );
            },
            offlineConsClick: () => {
                navigate(
                    `/consumption/${workorderItemsRedux.selectedWorkorders[0].lineId}/${workorderItemsRedux.selectedWorkorders[0].operationId}`
                );
            },
            assignLablClick: async () => {
                dispatch(
                    assignWorkorderItemRedux({
                        workorderItem: workorderItemsRedux.selectedWorkorders[0],
                        activityType: ActivityType.Labelling
                    }) as any
                );
            },
            assignConsClick: async () => {
                dispatch(
                    assignWorkorderItemRedux({
                        workorderItem: workorderItemsRedux.selectedWorkorders[0],
                        activityType: ActivityType.Consumption
                    }) as any
                );
            },
            manageWorkorderClick: () => {
                navigate(`/workordermanagement/${workorderItemsRedux.selectedWorkorders[0].workorderId}`);
            }
        };
    };

    const workorderItemsState = useSelector((state: IRootState) => state.workorderItems);

    React.useEffect(() => {
        if (workorderItemsState.assignedLabl){
            bootboxConfirm(translateString("workorderAssignedPrinting", aplSettings.culture), null, (resp: boolean) => {
                if (resp) navigate(`/labels/${workorderItemsRedux.selectedWorkorders[0].lineId}`);
            });
            dispatch(onClearAssigned());
        }
        if (workorderItemsState.assignedCons){
            bootboxConfirm(translateString("workorderAssignedConsumption", aplSettings.culture), null, (resp: boolean) => {
                if (resp) navigate(`/consumption/${workorderItemsRedux.selectedWorkorders[0].lineId}`);
            });
            dispatch(onClearAssigned());
        }
            
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workorderItemsState.assignedLabl, workorderItemsState.assignedCons]);

    return (
        <React.Fragment>
            <div id="divContainer" className="container mw-100">
                <div className="row">
                    <div className="col">
                        <WorkorderManagementSearch
                            showClosed={workorderItemsState.showClosed}
                            setShowClosed={e => dispatch(onSetShowClosed(e))}
                            workorderSearchString={workorderItemsState.workorderSearch}
                            setWorkorderSearchString={e => dispatch(onSetWorkorderSearch(e))}
                        />
                    </div>
                </div>

                <div className="row">
                    <div id="ajax-error-message" className="alert alert-danger hide" role="alert"></div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <DtGrid2 options={dtGridOptns}>
                            <WorkorderManagementDefaultRightClick options={getOptions()} />
                            <WorkorderManagementBottomButtons options={getOptions()} />
                        </DtGrid2>
                    </div>
                </div>
            </div>
            <ModalError aplError={workorderItemsRedux.workorderItemsError} culture={aplSettings.culture} okCallback={() => {dispatch(setWorkorderItemsError(null))}} />
        </React.Fragment>
    );
};

export default WorkorderManagementDefault;
